import { RouteFactory } from "@app/routePaths";
import DTAAboutPage from "@dta/components/DTAAboutPage";
import DTAAwardsPage from "@dta/components/DTAAwardsPage";
import DTAContactUsPage from "@dta/components/DTAContactUsPage";
import DTAJudgesPage from "@dta/components/DTAJudgesPage";
import DTAPartnersPage from "@dta/components/DTAPartnersPage";
import DTAHowToNominatePage from "@dta/components/HowToNominate/DTAHowToNominatePage";
import E50AboutPage from "@e50/components/E50AboutPage";
import E50AwardsPage from "@e50/components/E50AwardsPage";
import E50ContactUsPage from "@e50/components/E50ContactUsPage";
import E50FaqPage from "@e50/components/FAQ/E50FaqPage";
import E50HowToNominatePage from "@e50/components/HowToNominate/E50HowToNominatePage";
import EEAboutPage from "@ee/components/EEAboutPage";
import EEApplyNowPage from "@ee/components/EEApplyNowPage";
import EEAwardsPage from "@ee/components/EEAwardsPage";
import EEContactUsPage from "@ee/components/EEContactUsPage";
import EEFAQPage from "@ee/components/FAQ/EEFAQPage";
import EEHowToNominatePage from "@ee/components/HowToNominate/EEHowToNominatePage";
import EEPartnersPage from "@ee/components/Partners/EEPartnersPage";
import SBAHowToNominatePage from "@sba/components/HowToNominate/SBAHowToNominatePage";
import SBAAboutPage from "@sba/components/SBAAboutPage";
import SBAAwardsPage from "@sba/components/SBAAwardsPage";
import SBAContactUsPage from "@sba/components/SBAContactUs";
import SBASingleAwardPage from "@sba/components/SBASingleAwardPage";
import FAQPage from "@sca/components/FAQ/FAQPage";
import SCAHowToNominatePage from "@sca/components/HowToNominate/SCAHowToNominatePage";
import PartnersPage from "@sca/components/Partners/PartnersPage";
import SCAAboutPage from "@sca/components/SCAAboutPage";
import SCAAwardsPage from "@sca/components/SCAAwardsPage";
import SCAContactUsPage from "@sca/components/SCAContactUsPage";
import SCASingleAwardPage from "@sca/components/SCASingleAwardPage";
import SIAHowToNominatePage from "@sia/components/HowToNominate/SIAHowToNominatePage";
import SIAAboutPage from "@sia/components/SIAAboutPage";
import SIAAwardsPage from "@sia/components/SIAAwardsPage";
import SIAContactUsPage from "@sia/components/SIAContactUsPage";
import SIAJudgesPage from "@sia/components/SIAJudgesPage";
import SIAPartnersPage from "@sia/components/SIAPartnersPage";

type LayoutFactoryProps = {
  /**  The path of the page. */
  urlPath: string;
};

/**
 * This is the factory for the events awards static components.
 */
const LayoutFactory = ({ urlPath }: LayoutFactoryProps): React.ReactElement => {
  if (urlPath === RouteFactory.siaAboutPage) {
    return <SIAAboutPage />;
  }

  if (urlPath === RouteFactory.siaAwardsPage) {
    return <SIAAwardsPage />;
  }

  if (urlPath === RouteFactory.siaNominatePage) {
    return <SIAHowToNominatePage />;
  }

  if (urlPath === RouteFactory.siaPartnersPage) {
    return <SIAPartnersPage />;
  }

  if (urlPath === RouteFactory.siaContactUsPage) {
    return <SIAContactUsPage />;
  }

  if (urlPath === RouteFactory.siaJudgesPage) {
    return <SIAJudgesPage />;
  }

  if (urlPath === RouteFactory.sbaAboutPage) {
    return <SBAAboutPage />;
  }

  if (urlPath === RouteFactory.sbaAwardsPage) {
    return <SBAAwardsPage />;
  }

  if (urlPath === RouteFactory.sbaNominatePage) {
    return <SBAHowToNominatePage />;
  }

  if (urlPath === RouteFactory.sbaContactUsPage) {
    return <SBAContactUsPage />;
  }

  if (urlPath === RouteFactory.scaContactUsPage) {
    return <SCAContactUsPage />;
  }

  if (urlPath === RouteFactory.scaAboutPage) {
    return <SCAAboutPage />;
  }

  if (urlPath === RouteFactory.scaAwardsPage) {
    return <SCAAwardsPage />;
  }

  if (urlPath === RouteFactory.scaNominatePage) {
    return <SCAHowToNominatePage />;
  }

  if (urlPath === RouteFactory.scaFaqPage) {
    return <FAQPage />;
  }

  if (urlPath === RouteFactory.scaPartnersPage) {
    return <PartnersPage />;
  }

  if (urlPath.startsWith("/events-awards/singapore-corporate-awards/awards/")) {
    return <SCASingleAwardPage />;
  }

  if (urlPath === RouteFactory.eeAboutPage) {
    return <EEAboutPage />;
  }

  if (urlPath === RouteFactory.eeApplyNowPage) {
    return <EEApplyNowPage />;
  }

  if (urlPath === RouteFactory.eeAwardsPage) {
    return <EEAwardsPage />;
  }

  if (urlPath === RouteFactory.eeContactUsPage) {
    return <EEContactUsPage />;
  }

  if (urlPath === RouteFactory.eeFaqPage) {
    return <EEFAQPage />;
  }

  if (urlPath === RouteFactory.eeNominatePage) {
    return <EEHowToNominatePage />;
  }

  if (urlPath === RouteFactory.eePartnersPage) {
    return <EEPartnersPage />;
  }

  if (urlPath === RouteFactory.e50AboutPage) {
    return <E50AboutPage />;
  }

  if (urlPath === RouteFactory.e50AwardsPage) {
    return <E50AwardsPage />;
  }

  if (urlPath === RouteFactory.e50ContactUsPage) {
    return <E50ContactUsPage />;
  }

  if (urlPath === RouteFactory.e50FaqPage) {
    return <E50FaqPage />;
  }

  if (urlPath === RouteFactory.e50NominatePage) {
    return <E50HowToNominatePage />;
  }

  if (urlPath === RouteFactory.dtaAboutPage) {
    return <DTAAboutPage />;
  }

  if (urlPath === RouteFactory.dtaAwardsPage) {
    return <DTAAwardsPage />;
  }

  if (urlPath === RouteFactory.dtaJudgesPage) {
    return <DTAJudgesPage />;
  }

  if (urlPath === RouteFactory.dtaContactUsPage) {
    return <DTAContactUsPage />;
  }

  if (urlPath === RouteFactory.dtaNominatePage) {
    return <DTAHowToNominatePage />;
  }

  if (urlPath === RouteFactory.dtaPartnersPage) {
    return <DTAPartnersPage />;
  }

  if (urlPath.startsWith("/events-awards/singapore-business-awards/awards/")) {
    return <SBASingleAwardPage />;
  }

  return <></>;
};

export default LayoutFactory;
